<template>
    <v-container class="pa-1">
        <v-row class="d-flex justify-center">
            <v-col cols="12" sm="10" md="12" class="d-flex justify-center">
                <v-card rounded="lg" width="750" class="flex-grow-0 flex-shrink-0">
                    <v-row class="px-4 pb-0 pt-10">
                        <v-col cols="12" class="d-flex justify-end">
                            <v-btn v-if="labelEstadoPostulacion" class="text-none rounded-xl pa-0 ma-0 no-event" width="110" color="#B3B3B3">{{
                                labelEstadoPostulacion }}</v-btn>
                        </v-col>
                        <v-col :cols="dynamicColsImg" class="d-flex justify-center align-start degradado_card">
                            <v-img class="rounded-lg" :src="imagen" :aspect-ratio="16 / 9" contain></v-img>
                        </v-col>
                        <v-col :class="dynamicPaddingMargin">
                            <v-row dense class="fill-height d-flex align-center">
                                <v-col cols="12">
                                    <v-col cols="12" class="mt-0 mb-0 ml-0 pl-0 pt-0 pb-2">
                                        <h3 class="primary--text font-weight-bolder museo-text bolder-text">{{
                                            nombre_plaza }}</h3>
                                    </v-col>
                                    <v-col cols="12" class="mt-0 mb-0 ml-0 pl-0 pt-0 pb-0">
                                        <h4 class="primary--text font-weight-regular">{{ nombre_establecimiento }}</h4>
                                    </v-col>
                                    <v-col cols="12" class="mt-0 mb-0 ml-0 pl-0 pt-0 pb-0">
                                        <h4 class="primary--text font-weight-regular">{{ nombre_unidad }}</h4>
                                    </v-col>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row class="px-1 pb-4 pt-0 mx-0 my-0">
                        <v-col class="ml-0 pl-0 mr-0 pr-0">
                            <v-row dense :class="['d-flex', mostrarBotonProceso ? 'justify-space-between' : 'justify-start']">
                                <v-col cols="12" sm="auto" :class="[dynamicPaddingMrgBtn, 'd-flex justify-center']">
                                    <v-btn class="text-none rounded-xl pa-0 ma-0" width="215" max-width="215"
                                        color="primary" outlined :block="dynamicBtnBlockStyle"
                                        @click.stop="$emit('on-click-favorito', id)">
                                        <v-icon small color="primary">
                                            {{ item?.favoritos[0]?.activo ? 'mdi-heart' : 'mdi-heart-outline' }}
                                        </v-icon>
                                        {{ item?.favoritos[0]?.activo ? 'Quitar de mis favoritos' : 'Agregar a favoritos' }}
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" sm="auto" :class="[dynamicPaddingMrgBtn, 'd-flex justify-center']">
                                    <v-btn width="215" max-width="215" class="text-none rounded-xl pa-0 ma-0"
                                        color="primary" dark :block="dynamicBtnBlockStyle" @click="onClickDetalle">
                                        Ver oferta
                                    </v-btn>
                                </v-col>
                                <v-col v-if="mostrarBotonProceso" cols="12" sm="auto" :class="[dynamicPaddingMrgBtn, 'd-flex justify-center']">
                                    <v-btn width="215" max-width="215" class="text-none rounded-xl pa-0 ma-0"
                                        :block="dynamicBtnBlockStyle" @click="onClickProceso" color="#B3B3B3">
                                        <img src="/img/mi-proceso-postulacion-icon.svg" class="mr-1" width="16"
                                            height="16" alt="Mi proceso icon" />
                                        Mi proceso
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import imagenPlaza from '@/assets/img/goes-gray.png';
export default {
    name: "CardPostulacion",
    props: {
        item: {
            type: Object,
            default: () => ({

            })
        }
    },
    data() {
        return {
            nombre_unidad: null,
            nombre_plaza: null,
            imagen: null,
            id: null,
            nombre_establecimiento: null,
            windowWidth: window.innerWidth,
        }
    },
    methods: {
        onClickDetalle() {
            this.$emit("on-click-detalle", this.id);
        },
        onClickProceso() {
            this.$emit("on-click-proceso", this.id, this.item?.oferta_personas?.[0]?.id_oferta);
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
        firstLetterUpperCase(string) {
            return string?.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
        },
        obtenerMimeType(base64String) {
            const trimmed = base64String.trim();
            if (trimmed.startsWith("iVBORw0KGgo")) return "image/png";
            if (trimmed.startsWith("/9j/")) return "image/jpeg";
            if (trimmed.startsWith("R0lGOD")) return "image/gif";
            if (trimmed.startsWith("UklGR")) return "image/webp";
            if (trimmed.startsWith("<svg")) return "image/svg+xml";
            return "image/*"
        }
    },
    computed: {
        labelEstadoPostulacion() {
            return this.item?.oferta_personas?.[0]?.estado_evaluacion || null;
        },
        mostrarBotonProceso() {
            return this.labelEstadoPostulacion?.trim().toLowerCase() !== 'suspendido';
        },
        screenWidth() {
            return this.windowWidth;
        },
        dynamicColsImg() {
            let cols = 4;
            if (this.screenWidth > 550 && this.screenWidth < 1430) {
                cols = 4
            }
            if (this.screenWidth > 470 && this.screenWidth < 550) {
                cols = 6
            }
            if (this.screenWidth < 470) {
                cols = 12
            }
            return cols;
        },
        dynamicPaddingMrgBtn() {
            if (this.screenWidth > 1430) {
                return 'px-4';
            }
            return 'px-3'
        },
        dynamicPaddingMargin() {
            if (this.screenWidth < 1430 && this.screenWidth) {
                return "pa-1.5 ma-1.5";
            }
            if (this.screenWidth > 1430) {
                return "pa-0 ma-0";
            }
            return "pa-2 ma-2";
        },
        dynamicColsBtn() {
            let cols = 4
            if (this.screenWidth >= 960 && this.screenWidth < 1000) {
                cols = 12
            }
            if (this.screenWidth < 620) {
                cols = 12
            }
            return cols
        },
        dynamicBtnBlockStyle() {
            if (this.screenWidth <= 1430) {
                return true;
            }
            return false;
        },
        customBreakpoint() {
            if (this.screenWidth > 1430) {
                return true;
            }
            return false;
        }
    },
    mounted() {
        const mimeType = this.item?.solicitud?.UnidadOrganizativa?.estable?.imagen_institucion?.mime_type || "*";
        window.addEventListener("resize", this.handleResize);
        this.nombre_unidad = this.item?.solicitud?.UnidadOrganizativa?.nombre.charAt(0).toUpperCase() + this.item?.solicitud?.UnidadOrganizativa?.nombre.slice(1).toLowerCase();
        this.nombre_plaza = this.item?.solicitud?.titulo_oferta;
        this.imagen = this.item?.solicitud?.UnidadOrganizativa?.estable?.imagen_institucion?.imagen_base64 ? `data:${mimeType};base64,${this.item?.solicitud?.UnidadOrganizativa?.estable?.imagen_institucion?.imagen_base64}` : imagenPlaza;
        this.id = this.item?.id
        this.nombre_establecimiento = this.firstLetterUpperCase(this.item?.solicitud?.UnidadOrganizativa?.estable?.nombre) ?? '';
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    }
}
</script>
<style scoped>
.museo-text {
    font-family: 'MuseoSans', sans-serif !important;
}

.bolder-text {
    -webkit-font-smoothing: antialiased;
    text-shadow: 0.2px 0 0 currentColor, -0.2px 0 0 currentColor;

}

.degradado_card .v-image::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, rgba(9, 30, 64, 0) 0%, #091E408C 100%);
    pointer-events: none;
}

.no-event {
    pointer-events: none;
}
</style>